module.exports = __webpack_public_path__ + "static/stadium-47807ef7225bd500d8e54334ac1e5e11.png";